import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=627c7a74&scoped=true"
import script from "./user-profile.vue?vue&type=script&lang=ts"
export * from "./user-profile.vue?vue&type=script&lang=ts"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=627c7a74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c7a74",
  null
  
)

export default component.exports